export const servicesData = [
  {
    title: 'General Medicine',
    text: `Comprehensive healthcare services for managing and preventing a wide range of conditions.`,
    icon: 'fas fa-stethoscope'
  },
  {
    title: 'Pediatrics',
    text: `Our pediatricians provide compassionate, expert care for children of all ages, from newborns to adolescents.`,
    icon: 'fas fa-baby'
  },
  {
    title: `Women's Health`,
    text: `Preventive care and treatment for women of all ages, including reproductive and gynecological health, menopause management, and more.`,
    icon: 'fas fa-female',
  },
  {
    title: 'Dermatology',
    text: `Comprehensive care for skin, hair, and nail conditions, including acne, eczema, psoriasis, and more.`,
    icon: 'fas fa-spa',
  },
]

export const generalMedicineData = [

]
 
export const pediatricsData = [
  {
    title: 'What is Pediatrics?',
    text: 'Pediatrics is a branch of medicine that specializes in the health and care of infants, children, and adolescents. This field of medicine focuses on the physical, emotional, and social well-being of children from birth until they reach adulthood',
    icon: 'fas fa-baby'
  },
  {
    title: 'Why Choose a Pediatrician?',
    text: 'Pediatricians have specialized training and experience in caring for children, and are equipped to handle the unique health needs of infants, children, and adolescents. They provide comprehensive medical care, from routine checkups to vaccinations.',
    icon: 'fas fa-user-md',
  },
  {
    title: 'Common Pediatric Health Issues',
    text: 'Children are susceptible to a variety of health conditions and illnesses, including asthma, allergies, ear infections, and respiratory infections. Pediatricians are trained to diagnose and treat these conditions, and can provide guidance and support to parents.',
    icon: 'fas fa-heartbeat',
  },
  {
    title: 'Importance of Preventive Care',
    text: 'Preventive care is essential for promoting and maintaining the health and well-being of children. Regular checkups and vaccinations can help prevent illnesses and identify any health concerns early on, when they are easier to treat.',
    icon: 'fas fa-heart-rate',
  }
]

export const pediatricsData2 = [
  {
    title: 'Pediatric Care',
    text: 'Regular checkups and screenings are key to keeping your child healthy.',
    icon: 'fas fa-hands-heart'
  },
  {
    title: 'Healthy Habits',
    text: 'Encouraging healthy habits early on can help your child establish a lifetime of good health.',
    icon: 'fas fa-leaf-heart',
  },
  {
    title: 'Childhood Illnesses',
    text: `Our pediatricians can help you manage your child's symptoms and provide effective treatments when needed.`,
    icon: 'fas fa-virus',
  },
  {
    title: 'Preventing Childhood Injuries',
    text: `Our pediatricians can provide guidance on injury prevention, including tips for car seat safety, sports safety, and more.`,
    icon: 'fas fa-user-injured',
  },
]

export const womensHealthData = [
  {
    title: 'Mental Health',
    text: `Mental health is a key component of women's health and well-being`,
    icon: 'fas fa-brain'
  },
  {
    title: 'Reproductive Health',
    text: `Prioritize your reproductive health with regular checkups.`,
    icon: 'fas fa-venus',
  },
  {
    title: `Menopause Management`,
    text: `Our healthcare center offers comprehensive menopause management services.`,
    icon: 'fas fa-female',
  },
  {
    title: 'Preventative Care',
    text: `Preventative care is an important part of maintaining your health and well-being.`,
    icon: 'fas fa-heartbeat',
  },
]

export const dermatologyData = [
  {
    title: 'Acne Treatment',
    text: `Acne is a common skin condition that affects millions of people.`,
    icon: 'fas fa-spa'
  },
  {
    title: 'Eczema Treatment',
    text: `Eczema is a common skin condition that causes red, itchy, and inflamed skin.`,
    icon: 'fas fa-spa',
  },
  {
    title: `Psoriasis Treatment`,
    text: `Psoriasis is a common skin condition that causes red, scaly patches of skin.`,
    icon: 'fas fa-spa',
  },
  {
    title: 'Skin Cancer Screening',
    text: `Skin cancer is the most common type of cancer in the United States.`,
    icon: 'fas fa-spa',
  },
]